import type { BookingSearchDTO } from '@/types/dto/agent';
import type { UpdateCustomerProfileRequestDTO } from '@/types/dto/customer-profile';

export type ProfileBookingType =
  | 'tickets'
  | 'travelPasses'
  | 'vouchers'
  | 'accountDetails';
export type ProfileBookingTimeType = 'active' | 'history';

export type UpdateCustomerProfileRequest = Omit<
  UpdateCustomerProfileRequestDTO,
  'salesPointId' | 'userId'
>;

export interface BookingSearchResponse {
  data: Array<BookingSearchDTO>;
  totalCount: number;
}

export enum GenderOptions {
  MALE = 'SEX.MALE',
  FEMALE = 'SEX.FEMALE',
  X = 'SEX.X',
}
